module.exports = __webpack_public_path__ + "static/media/blank-recordinng.4d7ab866.png";